<div class="header">
  <h3>{{'HISTORY.HEAD' | translate}}</h3>
</div>
<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>

  <div class="row row-eq-height">
     <div class="col-md-3">
        <div class="dropdown-label-group">
          <p-dropdown
          class="dv-dropdown"
          selectId="list"
          [options]="list"
          [(ngModel)]="searchUsername"
          [autoDisplayFirst]="false"
          placeholder="{{'HISTORY.USER' | translate}}"
          >
          </p-dropdown>
        <label for="list">{{'HISTORY.USER' | translate}}</label>
        </div>
      </div>

    <div class="col-md-3">
        <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="group"
          [options]="roles"
          [(ngModel)]="searchRole"
          [autoDisplayFirst]="false"
          placeholder="{{'HISTORY.ROLE' | translate}}"
        >
        </p-dropdown>
        <label for="group">{{'HISTORY.ROLE' | translate}}</label>
        </div>
      </div>

    <div class="col-md-6">
        <div class="dropdown-label-group">
          <p-dropdown
          class="dv-dropdown"
          [options]="historyLogType"
          [(ngModel)]="selectedAction"
          [panelStyle]="{minWidth: '520px'}"
          [autoDisplayFirst]="false"
          placeholder="Action"
           [style]="{'z-index': 4}"
          >
          </p-dropdown>
        <label for="action">{{'HISTORY.ACTION' | translate}}</label>
        </div>
      </div>

  </div>
  <div class="row row-eq-height m-t-10">
  <div class="col-md-6 m-t-10 form-group">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
                 placeholder="วันที่" readonly>
          <label for="calendarDropdown">Period (Date)</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation();sentdate(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>

</div>
</div>
<div class="box-parent position-relative z-1">

  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="optionChanged()"
  >
  </app-custom-pagination>

        <div class="scrollable m-t-30">
          <p-table #tt tableStyleClass="table" *ngIf="totalItems !== 0" [loading]="loading"
              [value]="tableData" [customSort]="true" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'HISTORY.DATE' | translate}}</th>
        <th scope="col">{{'HISTORY.TIME' | translate}}</th>
        <th scope="col">{{'HISTORY.ACTION-ISSUE' | translate}}</th>
        <th scope="col">{{'HISTORY.ACTION-LOG' | translate}}</th>
        <th scope="col">{{'HISTORY.ACTION-L-D' | translate}}</th>
        <th scope="col">{{'HISTORY.USER' | translate}}</th>
        <th scope="col">{{'HISTORY.ROLE' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{data.created_at | date:"dd/MM/yyyy" }}</td>
          <td>{{data.created_at | date: "HH:mm" }}</td>
          <td>{{ data.action_issue }}</td>
          <td>{{data.action_log}}</td>
          <td>{{data.description}}</td>
          <td>{{data.user_fullname}}</td>
          <td>{{data.role}}</td>
        </tr>
      </ng-template>
    </p-table>
        </div>


</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.component.html